import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateActivityType as UpdateActivityTypeMutation,
    UpdateActivityTypeVariables as UpdateActivityTypeVariables,
    ActivityTypeUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_ACTIVITY_TYPE from '../mutations/update-activity-type.graphql';

export const useUpdateActivityType = (): {
    updateActivityType: (arg1: ActivityTypeUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateActivityType, {loading, error}] = useMutation<
        UpdateActivityTypeMutation,
        UpdateActivityTypeVariables
    >(UPDATE_ACTIVITY_TYPE);

    return {
        updateActivityType: (input: ActivityTypeUpdateInput) =>
            updateActivityType({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
